import { z } from "zod";

const AuthFormSchema = z.object({
  email: z
    .string()
    .trim()
    .nonempty({ message: "Email is required" })
    .email({ message: "Email is invalid" }),
  password: z.string().nonempty({ message: "Password is required" }),
});

export { AuthFormSchema };
